module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAARElEQVR42mJiYGBIy4uxSaM3zQjl0B0wTVpyBMygNz3q41Efj/p41MejPh718aiPR3086uNRH4/6eNTHQ8jHgAAAAP//Wb3P854FbfMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/layer.png
// module id = ./src/assets/layer.png
// module chunks = 4016850265702045000